﻿import {HttpClientError, Store} from "@2d-front-monorepo/core";
import {
	AllPermitsResult, CreditCardProvider,
	CustomData, HolderId,
	HolderType,
	InstallationId,
	IntegraHolderData, PaymentMethod
} from "@2d-front-monorepo/permits-business";
import React, {Context, createContext, JSX, useEffect, useState} from 'react';
import {reportError} from "../functions";
import {useHttpClient} from "../hooks/useHttpClient";
import {userStore} from "./UserContext";

export interface PermitsState {
	permits: AllPermitsResult;
	holderData: IntegraHolderData;
}

export const permitsStore: Store<PermitsState> = new Store<PermitsState>({
	permits: {
		installationId: '' as InstallationId,
		hasArchived: false,
		holder: {
			id: '' as HolderId,
			email: '',
			type: HolderType.Individual,
			attachments: [],
			customData: []
		},
		permits: [],
		drivers: [],
		residencies: [],
		vehicles: [],
		userState: {
			userCurrency:"",
			creditCardProvider: CreditCardProvider.Undefined,
			creditCardPan:"",
			paymentMethod: PaymentMethod.InvalidatedPaymethod,
			balance: 0
		}
	},
	holderData: {
		billingInfo: null!,
		plates: [],
		zones: [],
		tariffs: []
	},
});

export const PermitsContext: Context<Store<PermitsState>> = createContext<Store<PermitsState>>(permitsStore);

let version = 0;

export function PermitsProvider({children}: { children: React.ReactNode }): JSX.Element {
	const [, setVersion] = useState(0);

	useEffect(() => {
		return permitsStore.subscribe(() => setVersion(++version));
	}, []);

	return (
		<PermitsContext.Provider value={permitsStore}>
			{children}
		</PermitsContext.Provider>
	);
}

export async function reloadPermits(): Promise<AllPermitsResult | undefined> {
	try {
		const httpClient = useHttpClient();
		const allPermits = await httpClient.permits.list();
		const serverData = CustomData.getObject<IntegraHolderData>(allPermits.holder, "::integra-server-data");

		if (serverData == null) {
			await httpClient.authentication.signOff();

			userStore.patchState(state => {
				state.authStatus = "unauthorized";
			});

		} else {
			userStore.patchState(state => {
				state.email = allPermits.holder.email;
				state.authStatus = "logged-in";
			});

			permitsStore.patchState(x => {
				x.permits = allPermits
				x.holderData = serverData;
			});
		}

		return allPermits;

	} catch (error) {
		if (error instanceof HttpClientError && error.status === 401) {
			return;
		}

		reportError(error);
	}

	return undefined;
}
